import { api } from "boot/axios";

export default () => {
  //Send Feedback
  const sendFeedback = async (formData) => {
    try {
      const data = await api.post("/info/feedback/", formData);

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  //Get FAQ
  const getFAQ = async () => {
    try {
      const data = await api.get("/info/faq/");

      return data;
    } catch (error) {
      throw new Error(error);
    }
  };

  return {
    sendFeedback,
    getFAQ,
  };
};
